import React from 'react';
import { CheckCircleOutline, ErrorOutline, HelpOutline, WarningAmber } from '@mui/icons-material';

import { BaseStatusChip } from '../../../Paylinks/components/StatusChip';
import {
  colorDisabled,
  colorError,
  colorSuccess,
  colorWarning,
  StatusColor,
} from '../../../../util/constants';
import { DRIFT_LEVEL_LABEL, DriftLevel } from './formatMetrics';

export const DRIFT_LEVEL_COLOR: Record<DriftLevel, StatusColor> = {
  unknown: colorDisabled,
  stable: colorSuccess,
  watch: colorWarning,
  high: colorError,
};

const DRIFT_LEVEL_ICON: Record<DriftLevel, JSX.Element> = {
  unknown: <HelpOutline />,
  stable: <CheckCircleOutline />,
  watch: <WarningAmber />,
  high: <ErrorOutline />,
};

type DriftStatusChipProps = {
  level: DriftLevel;
  size?: 'small' | 'medium';
};

export const DriftStatusChip = ({ level, size = 'small' }: DriftStatusChipProps) => (
  <BaseStatusChip
    color={DRIFT_LEVEL_COLOR[level]}
    icon={DRIFT_LEVEL_ICON[level]}
    label={DRIFT_LEVEL_LABEL[level]}
    size={size}
    data-testid={`ella-drift-status-${level}`}
  />
);
